import { requiredFeaturesCompanyLevel } from "@utils/feature-control/company/company-feature-control-helper";
/**
 * Checks whether a feature is enabled and permitted to use by the user within the company level.
 *
 * @returns True if the feature is enabled and permitted within company level.
 */
export function hasUserValidFeatureCompanyLevel({
  featureName,
  featuresAvailable,
  defaultRequiredFeaturesCompanyLevel = requiredFeaturesCompanyLevel
}) {
  // Checks if the user has the required features roles for the company
  if (defaultRequiredFeaturesCompanyLevel[featureName].companySubscriptionRoles && hasFeatureCompanyLevel({
    featuresAvailable: featuresAvailable ?? null,
    requiredCompanyFeatures: defaultRequiredFeaturesCompanyLevel[featureName].companySubscriptionRoles
  })) {
    return true;
  }

  // If the user didn't match any of the rules above it means it
  // does not have permission.
  return false;
}

/**
 * Checks whether required features are available for the company level in featuresAvailable list.
 * This requires both the "enabled" and "permitted" properties to be true.
 * @returns True if the company has required subscription.
 */
export function hasFeatureCompanyLevel({
  featuresAvailable,
  requiredCompanyFeatures
}) {
  // Early return if there is no available features provided
  if (!featuresAvailable) {
    return false;
  }

  /**
   * Early return if there is no required company features
   * In this case there is no required features
   */
  if (!requiredCompanyFeatures.length) {
    return true;
  }
  if (featuresAvailable && featuresAvailable.length > 0) {
    return requiredCompanyFeatures.every(requiredCompanyFeature => {
      const feature = featuresAvailable.find(feature => feature.identifier === requiredCompanyFeature);
      if (!feature?.enabled) {
        return false;
      }
      return feature.permitted;
    });
  }

  // Returning false if no criteria met
  return false;
}